import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import TagManager from 'react-gtm-module';

export const usePageTracking = () => {
  const location = useLocation();
  useEffect(() => {
    TagManager.initialize({ gtmId: process.env.REACT_APP_GTM_ID! });
  }, [location]);
};
